import onDocumentLoad from './helpers/on-document-load';
import { UIController } from './controllers/ui.controller';
import { NavController } from './controllers/nav.controller';
import { HomeController } from './controllers/home.controller';
import { NewsController } from './controllers/news.controller';
import { TeamMembersController } from './controllers/team-members.controller';
export var APP = {
    init: function () {
        return Promise.all([
            UIController.init(),
            NavController.init(),
            HomeController.init(),
            NewsController.init(),
            TeamMembersController.init(),
        ]);
    },
};
onDocumentLoad(APP.init);
